import { ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";

/**
 * This is to hold all the different types of actions that a character can 
 * take on their turn.  
 * 
 * Attack: Make a non-magical attack or attacks
 * Magic: Cast a spell that takes an action, or use a magic item that takes an action to activate
 * Disengage: 
 * Hide
 * Dash
 * Jump, 
 * Search, 
 * Study, 
 * Influence, 
 * Help,
 * Opportunity Attack
 */
export interface ActionType extends ModelBase {
  data_type: "action_type";
  _id: string;
  name: string;
  description: string;
  casting_times: string[]; // = ["A"]; // For D&D
  display_specials: ("Attack" | "Ability" | "Spell" | "Item Action" | "Description")[]; // = [];
  display_us: string[]; // = []; // skill_id
  standard_action_cost: number; // = 1;

  // constructor(obj?: any) {
  //   super(obj);
  //   if (obj) {
  //     this.casting_times = obj.casting_times ? obj.casting_times : ["A"];
  //     this.display_us = obj.display_us ? obj.display_us : [];
  //     this.display_specials = obj.display_specials ? obj.display_specials : [];
  //     this.standard_action_cost = obj.standard_action_cost ? obj.standard_action_cost : 1;
  //   }
  // }

  // toDBObj(): any {
  //   const super_obj = super.toDBObj();
  //   return {
  //     ...super_obj,
  //     casting_times: this.casting_times,
  //     display_us: this.display_us,
  //     display_specials: this.display_specials,
  //     standard_action_cost: this.standard_action_cost
  //   };
  // }

  // copy(copyMe: ActionType, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  //   this.casting_times = [...copyMe.casting_times];
  //   this.display_us = [...copyMe.display_us];
  //   this.display_specials = [...copyMe.display_specials];
  //   this.standard_action_cost = copyMe.standard_action_cost;
  // }

  // clone(drop_ids: boolean = false): ActionType {
  //   const new_obj = new ActionType();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }
}

export const ACTION_TYPES: ActionType[] = [
  {
    data_type: "action_type",
    _id: "6346d7059a808b224cf8b804",
    name: "Attack",
    description: "When you take the Attack Action, you can make one attack with a Weapon or an Unarmed Strike.\n\nEQUIPPING WEAPONS\n\nYou can equip or unequip one Weapon before or after any attack you make as part of this Action, even if the attack is with an Unarmed Strike.\n\nMOVING BETWEEN ATTACKS\n\nIf you Move on your turn, you can use some or all of that movement to move between the attacks of this Action if you have a feature, such as Extra Attack, that gives you more than one attack as part of the Attack Action.",
    casting_times: ["A", "BA", "RA"],
    display_us: [],
    display_specials: ["Attack"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false 
  },
  {
    data_type: "action_type",
    _id: "6346d7c39a808b224cf8b805",
    name: "Magic",
    description: "When you take the Magic Action, you cast a Spell that has a casting time of an Action, or you use a Magic Item that requires an Action to be activated.\n\nIf you cast a Spell that has a casting time of 1 minute or longer, you must take the Magic Action on each turn of that casting, and you must maintain Concentration while you do so. If your Concentration is broken, the Spell fails, but you don’t expend a Spell Slot.",
    casting_times: ["A", "BA", "RA"],
    display_us: [],
    display_specials: ["Spell", "Item Action"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false, 
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346d8459a808b224cf8b806",
    name: "Dash",
    description: "Taking the Dash Action allows you to make a bonus Move during the current turn.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346d8899a808b224cf8b807",
    name: "Help",
    description: "When you take the Help Action, you do one of the following: Assist Ability Check, Assist Attack Roll.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346d8df9a808b224cf8b808",
    name: "Hide",
    description: "With the Hide Action, you try to conceal yourself. \n\nTo do so, you must make a DC 15 Dexterity Check (Stealth) while you’re Heavily Obscured or behind Three-Quarters Cover or Total Cover, and you must be out of any visible enemy’s line of sight; if you can see a creature, you can discern whether it can see you. On a successful check, you are Hidden. \n\nMake note of your check’s total, which becomes the DC for a creature to find you with a Wisdom Check (Perception).",
    casting_times: ["A"],
    display_us: ["5fc57494f3e883057c6bbb2f"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346da1a9a808b224cf8b809",
    name: "Influence",
    description: "With the Influence Action, you can try to influence another creature to do something you request or demand. This Action can be used only on creatures controlled by the DM, and it isn’t mind control; it can’t force a creature to do something that is counter to the creature’s alignment or that is otherwise repugnant to the creature. This Action has three main parts: Attitude, interaction, and a Charisma Check.\n\nATTITUDE\n\nA creature’s Attitude determines how a character can influence that creature. Each DM controlled creature has one of the following \n\nAttitudes toward the player characters:\n\nIndifferent. This is the default Attitude for DM controlled creatures. An Indifferent creature might help or hinder the party, depending on what the creature sees as most beneficial. A creature’s indifference doesn’t necessarily make it standoffish or disinterested. Indifferent creatures might be polite and genial, surly and irritable, or anything in between. A successful Charisma Check is often necessary when the adventurers try to persuade an Indifferent creature to do something.\n\nFriendly. A Friendly creature wants to help the adventurers and wishes for them to succeed. For tasks or actions that require no particular risk, effort, or cost, Friendly creatures often help happily. If an element of personal risk is involved, a successful Charisma Check might be required to convince a Friendly creature to take that risk.\n\nHostile. A Hostile creature opposes the adventurers and their goals but doesn’t necessarily attack them on sight. The adventurers need to succeed on one or more challenging Charisma Checks to convince a Hostile creature to do anything on the party’s behalf; however, the DM might determine that the Hostile creature is so ill-disposed toward the characters that no Charisma Check can sway it, in which case the first check fails automatically and no further Influence attempts can be made on the creature unless its Attitude shifts.\n\nINTERACTION \n\nWhen you take the Influence Action, either roleplay how your character interacts with the creature or describe your character’s behavior—focusing on your character’s request or demand. If the interaction is especially suited to the creature’s desires and outlook, the DM might grant Advantage to your subsequent check or might temporarily shift a Hostile creature to Indifferent or an Indifferent creature to Friendly. Similarly, if the interaction is particularly irksome to the creature, the DM might impose Disadvantage on your subsequent check or might temporarily shift a Friendly creature to Indifferent or an Indifferent creature to Hostile.\n\nABILITY CHECK\n\nTo determine whether your request or demand is successful, you make a Charisma Check (Animal Handling, Deception, Intimidation, or Persuasion); the applicable Skill depends on the interaction, with Animal Handling being reserved for Beasts and Monstrosities. Also, each request or demand requires a different check.\n\nThe creature’s Attitude determines the DC required to achieve a specific response, as shown in the Influence Responses table.\n\nInfluence Responses\n\nDC Indifferent Creature’s Response\n10 The creature does as asked, as long as no\nrisks or sacrifices are involved.\n20 The creature accepts a minor risk or\nsacrifice to do as asked.\n\nDC Friendly Creature’s Response\n10 The creature accepts a minor risk or\nsacrifice to do as asked.\n20 The creature accepts a significant risk or\nsacrifice to do as asked.\n\nDC Hostile Creature’s Response\n10 The creature offers no help but does no\nharm.\n20 The creature does as asked, as long as no\nrisks or sacrifices are involved.",
    casting_times: ["A"],
    display_us: ["5fef74287494ba20cca8a9e3", "5fe2ba391a2444180ced3b4f", "5fef742b7494ba20cca8a9e8", "5fef74307494ba20cca8a9ee"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346da679a808b224cf8b80a",
    name: "Jump",
    description: "With the Jump Action, you attempt to leap more than 5 feet (a jump of 5 feet or less is treated as Difficult Terrain). When you take this Action, your Speed must be greater than 0, and you must make a DC 10 Strength Check (Acrobatics or Athletics). If you don’t Move at least 10 feet immediately before this Action, you have Disadvantage on the check. On a failed check, you leap 5 feet horizontally or vertically.\n\nOn a successful check, the check’s totaldetermines the distance in feet that you can clear horizontally, or half that total if you’re jumping vertically (round down). This jump doesn’t expend your movement, but the distance you clear can’t exceed your Speed.",
    casting_times: ["A"],
    display_us: ["5fef74287494ba20cca8a9e2", "5fef74297494ba20cca8a9e5"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346dad59a808b224cf8b80b",
    name: "Search",
    description: "When you take the Search Action, you make a Wisdom Check to discern something that isn’t obvious. The Search table suggests which Skills are applicable when you take this Action, depending on what you’re trying to detect.\n\nSEARCH\nSkill Thing to Detect\nInsight Creature’s state of mind\nMedicine Creature’s ailment\nPerception Concealed creature or object\nSurvival Tracks or food",
    casting_times: ["A"],
    display_us: ["5fef742b7494ba20cca8a9e7", "5fef742d7494ba20cca8a9ea", "5fef742e7494ba20cca8a9ec", "5fef74317494ba20cca8a9f0"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "6346db7f9a808b224cf8b80c",
    name: "Study",
    description: "When you take the Study Action, you make an Intelligence Check to study your memory, a book, a creature, a clue, an object, or another source of knowledge and call to mind an important piece of information about it.\n\nThe Areas of Knowledge table suggests which Skills are applicable when you take this Action, depending on the area of knowledge the Intelligence Check is about.\n\nAREAS OF KNOWLEDGE\nSkill Areas\n\nArcana \n\nSpells, magic items, eldritch symbols, magical traditions, planes of existence, and certain creatures (Aberrations, Constructs, Elementals, Fey, and Monstrosities)\nHistory Historic events and people, ancient civilizations, wars, and certain creatures (Giants and Humanoids)\n\nInvestigation \n\nTraps, ciphers, riddles, and gadgetry\n\nNature \n\nTerrain, flora, weather, and certain creatures (Beasts, Dragons, Oozes, and Plants)\n\nReligion \n\nDeities, religious hierarchies and rites, holy symbols, cults, andcertain creatures (Celestials, Fiends,and Undead)",
    casting_times: ["A"],
    display_us: ["5fef74297494ba20cca8a9e4", "5fef742a7494ba20cca8a9e6", "5fef742c7494ba20cca8a9e9", "5fef742d7494ba20cca8a9eb", "5fef74307494ba20cca8a9ef"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "634714ac9a808b224cf8b80d",
    name: "Disengage",
    description: "Taking the Disengage Action allows you to move out of melee range without triggering attacks of opportunity.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475c4579fe2d0009ff9984",
    name: "Dodge",
    description: "Taking the dodge action causes incoming attacks to be done at disadvantage.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475c7479fe2d0009ff9985",
    name: "Grapple",
    description: "The 5e rules for grapple takes an action and you have to succeed on a contested check of your athletics vs their acrobatics or athletics.\n\nIn 1D&D a successful unarmed strike can grapple the target.",
    casting_times: ["A"],
    display_us: ["5fef74297494ba20cca8a9e5"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475db58116e500096dc5c8",
    name: "Improvise",
    description: "This is a catch all action for when you are doing something that doesn’t fit in any of the other actions. The DM may have you make a check that seems relevant.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475e1e8116e500096dc5c9",
    name: "Ready",
    description: "This allows you to ready an attack or a magic action and then do that action as a reaction to the event that you specify if it happens before your next turn.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475e3e8116e500096dc5ca",
    name: "Shove",
    description: "This is a contested check of your athletics vs the targets acrobatics or athletics.",
    casting_times: ["A"],
    display_us: ["5fef74297494ba20cca8a9e5"],
    display_specials: [],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "63475edd8116e500096dc5cb",
    name: "Use an Object",
    description: "I think this was the action that was used for magic items before, but now they’re part of the magic action.",
    casting_times: ["A"],
    display_us: [],
    display_specials: ["Description"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "action_type",
    _id: "635ddc6afc27300009a7444f",
    name: "Special",
    description: "Holds special abilities",
    casting_times: ["A", "BA", "RA"],
    display_us: [],
    display_specials: ["Ability"],
    standard_action_cost: 1,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }
]